module.exports = __webpack_public_path__ + "static/media/48369769_2308753805866464_4848505786369835008_o-thumb.003075d1.jpg";